module.exports = __webpack_public_path__ + "img/s1.5511e6c5.png";